module.exports = __webpack_public_path__ + "media/images/front/top/knowledge_note_topbanner-613072fa96b846f9c5c793c93f72579a.jpeg";